import {createYandexMapHelper} from '../../classes/yandex-map-helper/yandex-map-helper/init-yandex-map';
import {YMAPS_API_KEY} from '../../classes/yandex-map-helper/constants';

const CONSTANTS_MANAGER_ID = 'constants-manager';
const OBJECTS_MANAGER_ID = 'objects-manager';
const PLACEMARK_MANAGER_ID = 'placemark-manager';

const initMap = ( yandexMapHelper ) => {
	initLines( yandexMapHelper );
	initPlacemarks( yandexMapHelper );
	initMapMove( yandexMapHelper );
};

const initPlacemarks = ( yandexMapHelper ) => {
	const mapContainer = yandexMapHelper.component.querySelector( 'div.map' );

	if ( !mapContainer )
	{
		return;
	}

	const dataJSON = JSON.parse( document.getElementById( 'data' ).textContent );

	if ( !dataJSON )
	{
		return;
	}

	const placemarksManager = yandexMapHelper.createObjectManager( PLACEMARK_MANAGER_ID, {
		clusterize: false,
		zIndex: 1,
	} );

	const placemarksById = {};
	
	Object.keys( dataJSON ).forEach( ( placeMarkData, index ) => {
		const {station_title, construction_status, address, page_open, is_ready, enabled, line_hex_color, uri, line_number, latitude, longitude, text} = dataJSON[placeMarkData];

		if ( !latitude || !longitude )
		{
			return;
		}

		const placemarkClass = 'build-object-placemark';
		const placemarkSelector = `div.${placemarkClass}`;
		const balloonClass = 'station-info';

		const arrowSvg = `
			<svg width="20" height="22"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21">
				<path fill="#0038AE" d="m14.285 9.5-5.716-6h2.763l6.668 7-6.668 7H8.569l5.716-6H2v-2h12.285Z" />
			</svg>
		`;

		let icon = '';

		// Убрать хардкод и получать иконки станций с бэка
		if ( line_number === '1' )
		{
			if ( construction_status === 'project' )
			{
				icon = '/styles/images/components/map/stations/project/projectRedStation.svg';
			}
			else if ( construction_status === 'construct' )
			{
				icon = '/styles/images/components/map/stations/construct/constructRedStation.svg';
			}
			else if ( construction_status === 'reconstruct' )
			{
				icon = '/styles/images/components/map/stations/reconstruct/reconstructRedStation.svg';
			}
			else
			{
				icon = '/styles/images/components/map/stations/redStation.svg'
			}
		}
		else if ( line_number === '2' )
		{
			if ( construction_status === 'project' )
			{
				icon = '/styles/images/components/map/stations/project/projectBlueStation.svg';
			}
			else if ( construction_status === 'construct' )
			{
				icon = '/styles/images/components/map/stations/construct/constructBlueStation.svg';
			}
			else if ( construction_status === 'reconstruct' )
			{
				icon = '/styles/images/components/map/stations/reconstruct/reconstructBlueStation.svg';
			}
			else
			{
				icon = '/styles/images/components/map/stations/blueStation.svg'
			}
		}
		else if ( line_number === '3' )
		{
			if ( construction_status === 'project' )
			{
				icon = '/styles/images/components/map/stations/project/projectGreenStation.svg';
			}
			else if ( construction_status === 'construct' )
			{
				icon = '/styles/images/components/map/stations/construct/constructGreenStation.svg';
			}
			else if ( construction_status === 'reconstruct' )
			{
				icon = '/styles/images/components/map/stations/reconstruct/reconstructGreenStation.svg';
			}
			else
			{
				icon = '/styles/images/components/map/stations/greenStation.svg'
			}
		}
		else if ( line_number === '4' )
		{
			if ( construction_status === 'project' )
			{
				icon = '/styles/images/components/map/stations/project/projectOrangeStation.svg';
			}
			else if ( construction_status === 'construct' )
			{
				icon = '/styles/images/components/map/stations/construct/constructOrangeStation.svg';
			}
			else if ( construction_status === 'reconstruct' )
			{
				icon = '/styles/images/components/map/stations/reconstruct/reconstructOrangeStation.svg';
			}
			else
			{
				icon = '/styles/images/components/map/stations/orangeStation.svg'
			}
		}
		else if ( line_number === '5' )
		{
			if ( construction_status === 'project' )
			{
				icon = '/styles/images/components/map/stations/project/projectPurpleStation.svg';
			}
			else if ( construction_status === 'construct' )
			{
				icon = '/styles/images/components/map/stations/construct/constructPurpleStation.svg';
			}
			else if ( construction_status === 'reconstruct' )
			{
				icon = '/styles/images/components/map/stations/reconstruct/reconstructPurpleStation.svg';
			}
			else
			{
				icon = '/styles/images/components/map/stations/purpleStation.svg'
			}
		}
		else if ( line_number === '6' )
		{
			if ( construction_status === 'project' )
			{
				icon = '/styles/images/components/map/stations/project/projectBrownStation.svg';
			}
			else if ( construction_status === 'construct' )
			{
				icon = '/styles/images/components/map/stations/construct/constructBrownStation.svg';
			}
			else if ( construction_status === 'reconstruct' )
			{
				icon = '/styles/images/components/map/stations/reconstruct/reconstructBrownStation.svg';
			}
			else
			{
				icon = '/styles/images/components/map/stations/brownStation.svg'
			}
		}

		const customId = is_ready === 'yes' ? 'open' : 'work';
		const constructionClass = construction_status !== 'none' ? construction_status : '';

		const placemarkProps = {
			type: 'Feature',
			id: `${index}`,
			geometry: {
				type: 'Point',
				coordinates: [latitude, longitude],
			},
			properties: {
				balloonContent: `<div class="${balloonClass} ${is_ready === 'yes' ? 'open' : 'close'}">
							<div>
								<h2>${station_title}</h2>
								<p class="open">${text}</p>
								<p class="address">${address}</p>
								${enabled === 'yes' && page_open === 'yes' ?
									`<a style="background-color: ${line_hex_color}" href="${uri}/">О станции${arrowSvg}</a>` 
									: ''}
							</div>
						</div>
				`,
			},
			options: {
				iconLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
					`<div class="${placemarkClass} ${customId} ${constructionClass} line-${line_number}" data-map-marker-id="${index}">
						<img src="${icon}" />
					</div>`,
					{
						build() {
							this.constructor.superclass.build.call( this );

							const placemark = this.getElement().querySelector( placemarkSelector );
							const img = this.getElement().querySelector( `${placemarkSelector} > img` );

							if ( placemark && img )
							{
								const width = placemark.offsetWidth;
								const height = placemark.offsetHeight;

								const shapeCoordinates = [
									[width / -2, -1 * height],
									[width / 2, width / 2],
								];

								const shapeRectangle = {
									type: `Rectangle`,
									coordinates: shapeCoordinates,
								};

								this.getData().options.set( `shape`, shapeRectangle );

								placemark.style.setProperty( 'position', 'absolute' );
								placemark.style.setProperty( 'left', '-12px' );
								placemark.style.setProperty( 'top', '-12px' );
							}
						},
					},
				),

				hideIconOnBalloonOpen: false,
				balloonShadow: false,
				balloonPanelMaxMapArea: 'Infinity',
				balloonAutoPanMargin: 0,
				balloonAutoPan: false,
				zIndex: 1,
			},
		};

		placemarksManager.add( placemarkProps );

		placemarksById[index] = dataJSON[placeMarkData];

		placemarksManager.events.add( ['mouseenter', 'mouseleave'], ( evt ) => {
			const type = evt.get( 'type' );
			const currentObjectId = evt.get( 'objectId' );

			const markerSelector = `.build-object-placemark[data-map-marker-id="${currentObjectId}"]`;
			let mapPoint = yandexMapHelper.mapContainer.querySelector( markerSelector );
			
			if ( mapPoint )
			{
				if ( type === 'mouseenter' )
				{
					mapPoint.classList.add( 'hover' );
				}
				
				if ( type === 'mouseleave' )
				{
					mapPoint.classList.remove( 'hover' );
				}
			}
		} );
	} );
	
	yandexMapHelper.yandexMap.events.add( 'click', () => {
		yandexMapHelper.yandexMap.balloon.close();
	} );
};

const initMapMove = ( yandexMapHelper ) => {
	const mapContainer = document.querySelector( 'section.map' );

	yandexMapHelper.yandexMap.events.add( 'actionbegin', () => {
		mapContainer.classList.add( 'move' );
	} );

	yandexMapHelper.yandexMap.events.add( 'actionend', () => {
		mapContainer.classList.remove( 'move' );
	} );
};

const initLines = ( yandexMapHelper ) => {
	const mapContainer = yandexMapHelper.component.querySelector( 'div.map' );

	if ( !mapContainer )
	{
		return;
	}

	const dataJSON = JSON.parse( document.getElementById( 'data' ).textContent );

	if ( !dataJSON )
	{
		return;
	}

	const lines = [];
	const linesColors = [];
	const allLinesLayer = [];

	const data = Object.values( dataJSON );

	data.forEach( ( station ) => {
		if ( station.longitude === '' || station.longitude === '' )
		{
			return;
		}

		if ( lines[station.line_number] && lines[station.line_number] )
		{
			lines[station.line_number].push( [station.latitude, station.longitude] );
		} else {
			lines[station.line_number] = [];
			lines[station.line_number].push( [station.latitude, station.longitude] );
		}

		linesColors[station.line_number] = station.line_hex_color;
	} );

	lines.forEach( ( line, index ) => {
		yandexMapHelper.yandexMap.geoObjects.add(
			allLinesLayer[index] = new yandexMapHelper.ymaps.Polyline(
				line,
				{
					baloonContent: '',
				},
				{
					strokeColor: linesColors[index],
					strokeWidth: 5,
					strokeOpacity: '0.6',
				},
			),
		);
	} );
};

const initFilters = ( mapContainer ) => {
	const tabs = Array.from( document.querySelectorAll( 'div.tabs button.filter' ) );

	mapContainer.addEventListener( 'click', ( {target} ) => {
		if ( target.closest( 'button.filter' ) )
		{
			target.closest( 'button.filter' ).classList.toggle( 'active' );

			const dataCurrent = target.getAttribute( 'data-current' );

			if ( !dataCurrent )
			{
				return;
			}

			if ( target.closest( 'button.active' ) )
			{
				if ( dataCurrent === 'project' )
				{
					mapContainer.classList.add( 'project-view' );
				}
				else if ( dataCurrent === 'construct' )
				{
					mapContainer.classList.add( 'construct-view' );
				}
				else if ( dataCurrent === 'reconstruct' )
				{
					mapContainer.classList.add( 'reconstruct-view' );
				}
				else
				{
					mapContainer.classList.add( 'open-view' );
				}
			}
			else
			{
				if ( dataCurrent === 'project' )
				{
					mapContainer.classList.remove( 'project-view' );
				}
				else if ( dataCurrent === 'construct' )
				{
					mapContainer.classList.remove( 'construct-view' );
				}
				else if ( dataCurrent === 'reconstruct' )
				{
					mapContainer.classList.remove( 'reconstruct-view' );
				}
				else
				{
					mapContainer.classList.remove( 'open-view' );
				}
			}

			const btns = document.querySelectorAll( 'button.filter' );
			const allPlacemarks = document.querySelectorAll( 'div.build-object-placemark' );
			
			const activeArr = [];

			btns.forEach( ( btn ) => {
				if ( btn.classList.contains( 'active' ) )
				{
					activeArr.push( btn );
				}
			} );

			if ( activeArr.length < 1 )
			{
				allPlacemarks.forEach( ( placemark ) => {
					placemark.classList.add( 'init' );
				} );

				mapContainer.classList.add( 'all-view' );
			}
			else
			{
				allPlacemarks.forEach( ( placemark ) => {
					placemark.classList.remove( 'init' );
				} );

				mapContainer.classList.remove( 'all-view' );
			}
		}
	} );
};

const initComponent = ( component ) =>
{
	if ( !component )
	{
		return;
	}

	const mapContainer = component.querySelector( 'div.map' );
	
	if ( mapContainer )
	{
		const mapProps = {
			ymapsApiKey: YMAPS_API_KEY,
			mapContainer,
			mapState: {
				center: [59.936711, 30.298469],
			},
			mapOptions: {
				minZoom: 10.2,
				maxZoom: 20,
			},
			component,
			readyCallback: initMap,
		};
		
		createYandexMapHelper( mapProps );

		initFilters( component );
	}
};

export const initMapComponent = () => {
	Array.from( document.querySelectorAll( 'section.map' ) )
		.forEach( ( component ) => {
			initComponent( component );
		} );
};
